import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";

export const SuccessModalIcon = () => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <TaskAltIcon
      sx={{
        color: colors.primary.primary,
        fontSize: 125,
        margin: "auto",
      }}
    />
  );
};
